<div>
    <p>{{subTitle}}</p>
    <h1>{{title}}</h1>
</div>